import { render, staticRenderFns } from "./GroupCensusFilter.vue?vue&type=template&id=50940a1c&scoped=true&"
import script from "./GroupCensusFilter.vue?vue&type=script&lang=js&"
export * from "./GroupCensusFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50940a1c",
  null
  
)

export default component.exports